module.exports = __webpack_public_path__ + "static/media/nodejs.9f1b2ef4.svg";